import { webApi } from '@mi-front/api-clients';

/**
 * Whether the project's latest render finished successfully (same rule as the project card "generated" state).
 */
export function isVideoEditorProjectRenderCompleted(
  project: webApi.EnrichedVideoEditorProjectListItemDto,
): boolean {
  return project.renderJob?.status === 'COMPLETED';
}
